import Button from '@/components/Button';
import { WildcardEntity } from '@/graphql/generated/graphql';
import DialogConfirmation from '@/components/confirmDialog/DialogConfirmation';
import { useAnnouncementsList } from '../../../hooks/useAnnouncementsList';
import { AnnouncementPreview } from '../preview';
import { AnnouncementInfo } from '../info';
import { motion, AnimatePresence } from 'framer-motion';
import { useAnnouncementStore } from '../../../store/announcementStore';

export const AnnouncementList = () => {
  const { page } = useAnnouncementStore();
  const {
    data,
    handleUnpublish,
    handlePublish,
    handleDelete,
    handleDuplicateAndRelaunch,
    handleEdit,
    deleteDialogOpen,
    setDeleteDialogOpen,
    confirmDelete,
    cancelDelete,
  } = useAnnouncementsList();

  return (
    <div className="flex w-full flex-col gap-sh-30 ">
      <DialogConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
        customTitle={page?.deleteDialog?.title ?? undefined}
        customDescription={page?.deleteDialog?.description ?? undefined}
        confirmButtonText={page?.deleteDialog?.confirmBtn ?? undefined}
        cancelButtonText={page?.deleteDialog?.cancelBtn ?? undefined}
      />
      <AnimatePresence>
        {data?.fetchWildcard?.map((wildcard) => (
          <motion.div
            key={wildcard.id}
            layout
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}>
            <div
              id={`announcement-${wildcard.id}`}
              className="flex grid-cols-1 flex-col items-center justify-center gap-4 rounded-2xl bg-white py-sh-30 sm:grid sm:grid-cols-2 sm:px-[40px]">
              <AnnouncementPreview wildcard={wildcard as WildcardEntity} />
              <AnnouncementInfo
                wildcard={wildcard as WildcardEntity}
                actions={
                  <div className="flex flex-wrap justify-center gap-sh-15">
                    {wildcard.attributes?.status === 'PUBLISHED' && (
                      <Button onClick={() => handleUnpublish(wildcard.id!)}>{page?.actions?.unpublishBtn}</Button>
                    )}
                    {wildcard.attributes?.status === 'DRAFT' && (
                      <Button onClick={() => handlePublish(wildcard.id!)}>{page?.actions?.publishBtn}</Button>
                    )}
                    <Button onClick={() => handleEdit(wildcard as WildcardEntity)}>{page?.actions?.editBtn}</Button>
                    <Button onClick={() => handleDuplicateAndRelaunch(wildcard as WildcardEntity)}>
                      {page?.actions?.duplicateBtn}
                    </Button>
                    {wildcard.attributes?.status === 'DRAFT' && (
                      <Button onClick={() => handleDelete(wildcard.id!)}>{page?.actions?.deleteBtn}</Button>
                    )}
                  </div>
                }
              />
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
